import React, { useRef, useLayoutEffect } from 'react';
import './factbox.scss';
import { lang } from '../lang';

function Factbox({ index }) {
  const { icon, copy, source } = lang.factbox[index];
  const allRefs = useRef();
  const box1 = useRef();
  const box2 = useRef();
  allRefs.current = [box1, box2];

  useLayoutEffect(() => {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0.3) {
            entry.target.style.animation = 'fade-in 0.5s linear forwards';
          }
        });
      },
      { threshold: [0, 0.3] }
    );
    allRefs.current.forEach((ref) => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });
  }, []);

  return (
    <figure className="factbox" ref={allRefs.current[index]}>
      <div className="factbox__content">
        <img src={icon} alt="" />
        <p>{copy}</p>
      </div>
      <figcaption>
        <span className="factbox__source">{source[0]}</span>
        {source[1]}
      </figcaption>
    </figure>
  );
}

export default Factbox;
